// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { EmptyCard } from 'components';
import { requestAppConfig } from 'ducks/appConfigActions';

type Props = {
  requestAppConfig: string => void,
  requestMerchantGroups: string => void,
  token: string,
  ready: boolean,
  status: RequestStatus,
  children?: React.Element<any>,
};

export class LoadAppConfig extends React.PureComponent<Props, void> {
  componentDidMount() {
    this.props.requestAppConfig(this.props.token);
  }

  render() {
    const { status, children } = this.props;

    if (status === ('complete': RequestStatus)) {
      return children;
    } else if (status instanceof Error) {
      return <EmptyCard message="Failed to load Application Configuration" />;
    }

    return <EmptyCard modal message="Loading Application Configuration..." />;
  }
}

function mapStateToProps(state: Object): Object {
  return {
    ready: state.appConfig.sagaReady,
    status: state.appConfig.requestStatus,
    token: state.auth.token,
  };
}

export default connect(mapStateToProps, {
  requestAppConfig,
})(LoadAppConfig);



// WEBPACK FOOTER //
// ./src/pages/__components__/LoadAppConfig.js